/**
 * The message catalogues. Modules' screens add their keys here as each is built, namespaced by module. Screens built
 * before this existed still hold English in their code, and move here when they are next worked on.
 */
export const catalogues = {
    'en-SG': {
        'people.name': 'People',
        'comms.name': 'Messages',
        'children.name': '{childrenMinistry}',
        'serving.name': 'Serving',
        'events.name': 'Events',
        'camps.name': 'Camp',
        'care.name': 'Care',
        'shell.import': 'Import',
        'shell.account': 'My sign-in',
        'shell.signOut': 'Sign out',
        'shell.skipToContent': 'Skip to the main content',
        'shell.mainMenu': 'Main menu',
        'shell.more': 'More',
        'shell.moreMenu': 'Everything in Trellistry',
        'shell.close': 'Close',
        'shell.findLabel': 'Find someone',
        'shell.findPlaceholder': 'Find someone…',
    },
    'zh-Hans-SG': {
        'people.name': '会友',
        'children.name': '{childrenMinistry}',
    },
};
//# sourceMappingURL=catalogues.js.map